"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormShareModal = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var store_1 = require("../../store");
var org_department_selector_1 = require("../org.department.selector/org.department.selector");
var form_share_modal_style_1 = require("./form.share.modal.style");
(0, theme_1.addStyles)(form_share_modal_style_1.Style);
var FormShareModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormShareModal, _super);
    function FormShareModal(ctx, formRevision) {
        var _this = _super.call(this, ctx) || this;
        _this.formRevision = formRevision;
        _this.departmentSelector = new org_department_selector_1.OrgDepartmentSelector();
        _this.addState(_this.departmentSelector.inputState);
        return _this;
    }
    Object.defineProperty(FormShareModal.prototype, "nodes", {
        get: function () {
            var formSummary = store_1.AppStore.FormSummary.get(this.formRevision);
            if (formSummary == null) {
                return spinner_1.Spinner.view();
            }
            return (0, mithril_1.m)('div', { className: form_share_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: form_share_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_SHARE_CONFIRM, { name: formSummary.displayname })),
                    this.departmentSelector.view()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    FormShareModal.prototype.submit = function () {
        var selectedDepartmentId = this.departmentSelector.selectedDepartmentId;
        if (selectedDepartmentId == null) {
            return null;
        }
        return services_1.Services.Form.share(this.formRevision, selectedDepartmentId);
    };
    return FormShareModal;
}(modal_form_component_1.ModalFormComponent));
exports.FormShareModal = FormShareModal;
//# sourceMappingURL=form.share.modal.js.map